import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeGrandTotalCommand extends BaseCommand {
  CommandName = "ChangeGrandTotal";
  Command: {
    Amount: number;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, amount: number) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Amount: amount };
  }
}
